import { useCallback } from 'react';
import { THandleReset } from './types';
import { IHandleInputParams, TInputState } from '../types';
import { reduce } from 'lodash';

export const useHandleReset = ({
  inputs,
  setInputs,
}: IHandleInputParams): THandleReset => {
  return useCallback(() => {
    setInputs(
      reduce(
        inputs,
        (r, v, k) => ({
          ...r,
          [k]: {
            ...v,
            reset: true,
          },
        }),
        {} as Record<string, TInputState>
      )
    );
  }, [inputs, setInputs]);
};
